export enum ECrocoAnimationStates {
    Idle = "idle",
    Run = "run",
    Fall = "fall"
}

export enum EGlowAnimationStates {
    Run = "run",
    Fall = "fall"
}

export enum EBackgroundAnimationStates {
    Idle = "background_idle",
    Run = "background_run"
}

export enum EForegroundAnimationStates {
    Idle = "foreground_idle",
    Run = "foreground_run"
}

export enum ESignAnimationStates {
    x2 = "x2",
    x5 = "x5",
    x10 = "x10",
    x50 = "x50",
    x100 = "x100",
    x200 = "x200",
    x300 = "x300",
    x400 = "x400",
    x500 = "x500",
    x600 = "x600",
    x700 = "x700",
    x800 = "x800",
    x900 = "x900",
    x1000 = "x1000",
    x2000 = "x2000",
    x3000 = "x3000",
    x4000 = "x4000",
    x5000 = "x5000",
    x6000 = "x6000",
    x7000 = "x7000",
    x8000 = "x8000",
    x9000 = "x9000",
    x10000 = "x10000"
}


export enum ECrocoGameApp {
    CrocoGameApp = "crocoGameApp",
    CrocoScreenGlowGameApp = "crocoScreenGlowGameApp"
}
